<!--Copy and paste the code below into
a separate view file.
Add content in v-col component, as described below.-->
<template>
    <!-- Responsive home page layout -->
      <v-app>    
        <v-container>
          <v-row justify="center">
            <!-- Navigation Bar -->
            <v-col cols="12" class="mb-8">
              <NavBar/>
            </v-col>
            <v-col cols="12"> 
                <div class="flex-box">
                    Favorites
                </div>
            </v-col>
          </v-row>
        </v-container>
      </v-app>
      <!-- Footer -->
      <MENDFooter></MENDFooter>
    </template>
    
    <script>
    // Imported components present in each page.
    import MENDFooter from './MENDFooter.vue';
    import NavBar from './NavBar.vue';
    
    export default {
      name: 'App',
      components: {
        NavBar,
        MENDFooter
      },
    }
    </script>
    
    <style>
    * {
      font-family: 'Montserrat';
    }
    
    .flex-box {
      display: flex;
      justify-content: center;
    }
    </style>